import { action } from '@ember/object';
import { equal } from '@ember/object/computed';
import Controller from '@ember/controller';
import LayoutModel from 'cio/models/layout';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';

export default class StartersController extends Controller {
  @service router!: RouterService;

  showNameModal = false;
  selectedStarterId = null;
  name = '';
  starterLayouts = [];

  @equal('item.name', 'Feedback') isFeedbackStarter!: boolean;

  resetStarterPage() {
    this.set('showNameModal', false);
    this.set('name', null);
    this.set('selectedStarterId', null);
  }

  @action
  selectItem(item: LayoutModel) {
    this.set('selectedStarterId', item.id);
    this.set('showNameModal', true);
  }

  @action
  addSelectedWithName(evt: SubmitEvent) {
    evt.preventDefault();

    let { name, selectedStarterId } = this.getProperties('name', 'selectedStarterId');
    this.resetStarterPage();
    this.router.transitionTo('layouts.new', { queryParams: { starter_layout_id: selectedStarterId, name } });
  }

  @action
  cancelAddLayout() {
    this.resetStarterPage();
  }
}
